import { Button, Dropdown, Input, Menu, Modal, Typography } from 'antd'
import axios from 'axios'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { QrReader } from 'react-qr-reader'
import { POST } from '../../utils/apis'
import { constraints } from '../../utils/constants'
import { assignMessage, errorMessage, successMessage } from '../../utils/helpers'
// import { Carousel } from 'react-responsive-carousel'

const { Title } = Typography
const AcceptGiftCards = (props) => {
    const { user, userActions, selectedLanguage, language } = props
    const [visible, setVisible] = useState(false)
    const [visibleQR, setVisibleQR] = useState(false)
    const [confirmLoading, setConfirmLoading] = useState(false)
    const [loading, setLoading] = useState(false)
    const [lottery, setLottery] = useState('')
    const [QRCode, setQRCode] = useState(null)
    const [giftCardDetail, setGiftCardDetail] = useState({})
    const [isModalVisible, setIsModalVisible] = useState(false)

    // useEffect(() => {
    //     getAllUserData(user?._id, userActions)
    // }, [])

    useEffect(() => {
        if (QRCode && !loading) {
            console.log('QRCode', QRCode)
            handleOk(QRCode)
        }
    }, [QRCode])

    const menu = (
        <Menu>
            <Menu.Item onClick={() => setVisible(true)} key='1'>{selectedLanguage?.ClaimByCode}</Menu.Item>
            <Menu.Item onClick={() => setVisibleQR(true)} key='2'>{selectedLanguage?.ClaimByQRCode}</Menu.Item>
        </Menu>
    )

    const handleOk = (code = null) => {
        setConfirmLoading(true)
        setLoading(true)

        axios.post(POST.VERIFY_GIFT_CARDS, { giftCardCode: lottery || code, userId: user?._id, userType: user?.userType })
            .then((res) => {
                const { data } = res
                if (data?.success) {
                    setGiftCardDetail(data?.data)
                    handleCancel()
                    setVisible(false)
                    setQRCode(null)
                    setVisibleQR(false)
                    setConfirmLoading(false)
                }
                else {
                    errorMessage(assignMessage(data?.message, language?.language))
                }
                setTimeout(() => {
                    setLoading(false)
                }, 500)
            })
            .catch((e) => {
                console.log('e ', e)
                setVisible(false)
                setConfirmLoading(false)
                setLoading(false)
                errorMessage(assignMessage(e?.message, language?.language))
            })

    }

    const handleCancel2 = () => {
        setVisible(false)
        setVisibleQR(false)
        setLottery('')
    }
    const handleCancel = () => {
        setVisible(false)
        setVisibleQR(false)
        showModal1()
        setLottery('')
    }

    const showModal1 = () => {
        setIsModalVisible(true)
    }

    const handlelotteryInput = (e) => {
        let newCode = e?.target?.value?.replace(/[^A-Za-z0-9]/g, '')
        newCode = newCode?.replace(/(.{3})/g, '$1-')
        newCode = newCode?.replace(/-$/, '')
        setLottery(newCode)
    }

    const sendAcceptRequest = () => {
        setLoading(true)
        let obj = {
            giftCardCode: giftCardDetail?.giftCardCode,
            userId: user?._id,
            _id: giftCardDetail?._id
        }
        axios.post(POST.GIFT_CARDS_ACCEPT_REQUESTS, obj)
            .then((res) => {
                const { data } = res
                if (data?.success) {
                    successMessage(assignMessage(data?.message, language?.language))
                    setIsModalVisible(false)
                    setGiftCardDetail({})
                }
                else {
                    errorMessage(assignMessage(data?.message, language?.language))
                }
                setTimeout(() => {
                    setLoading(false)
                }, 500)
            })
            .catch((e) => {
                console.log('e ', e)
                setLoading(false)
                errorMessage(assignMessage(e?.message, language?.language))
            })
    }
    const acceptCode = () => {
        setLoading(true)
        let obj = {
            giftCardCode: giftCardDetail?.giftCardCode,
            userId: user?._id,
            _id: giftCardDetail?._id
        }
        axios.post(POST.CLAIM_BU_GIFT_CARD, obj)
            .then((res) => {
                const { data } = res
                if (data?.success) {
                    successMessage(assignMessage(data?.message, language?.language))
                    setIsModalVisible(false)
                    setGiftCardDetail({})
                }
                else {
                    errorMessage(assignMessage(data?.message, language?.language))
                }
                setTimeout(() => {
                    setLoading(false)
                }, 500)
            })
            .catch((e) => {
                console.log('e ', e)
                setLoading(false)
                errorMessage(assignMessage(e?.message, language?.language))
            })
    }

    const scanQr = async qr => {
        let code = qr?.text

        if (code) {
            setQRCode(code)
        }
    }

    return (
        <div>
            <Dropdown overlay={menu} placement='bottomLeft'>
                <Button style={{ height: '40px', width: '180px', margin: '2px', marginTop: '10px' }}
                    className='addproduct-text'
                    type='primary'>
                    {selectedLanguage?.button_AcceptGiftCards}
                </Button>
            </Dropdown>
            <Modal
                // title={<center>
                //     <Title level={4} style={{ color: '#ec671b' }}>{selectedLanguage?.title_GiftCard}</Title>
                // </center>}
                className='pop-info-modal'
                style={{ top: '10px' }}

                open={visible}
                onOk={handleOk}
                confirmLoading={confirmLoading}
                onCancel={handleCancel2}
                footer={[
                    <Button key='back' onClick={handleCancel2} style={{ height: '40px', width: '140px', margin: '2px', marginTop: '10px' }}
                        className='addproduct-text'
                        type='primary' >
                        {selectedLanguage?.Cancel}
                    </Button>,
                    <Button
                        key='ok'
                        onClick={handleOk}
                        disabled={lottery?.length !== 11}
                        style={{ height: '40px', width: '140px', margin: '2px', marginTop: '10px' }}
                        className='addproduct-text'
                        type='primary'
                        loading={loading}
                    >
                        {selectedLanguage?.button_AcceptGiftCards}
                    </Button>
                ]}
            >
                <p className='new-p-question'>{selectedLanguage?.title_GiftCard}</p>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <h4 style={{ color: '#ec671b' }}>{selectedLanguage?.title_EnteryourGiftCardnumber}</h4>
                    <Input
                        className='form-input-new-style'
                        style={{ width: '100%' }}
                        autoFocus
                        required
                        maxLength={11}
                        value={lottery}
                        onChange={handlelotteryInput}
                        placeholder='e.g: 456-786-ab6'
                    />
                </div>
            </Modal>

            <Modal
                // title={<center>
                //     <Title level={4} style={{ color: '#ec671b' }}>{selectedLanguage?.ActivateQR}</Title>
                // </center>}
                className='pop-info-modal'
                style={{ top: '10px' }}
                open={visibleQR}
                onOk={handleOk}
                confirmLoading={confirmLoading}
                onCancel={handleCancel2}
                footer={[
                    <Button key='back' onClick={handleCancel2} style={{ height: '40px', width: '140px', margin: '2px', marginTop: '10px' }}
                        className='addproduct-text'
                        type='primary'>
                        {selectedLanguage?.Cancel}
                    </Button>
                ]}
            >
                <p className='new-p-question'>{selectedLanguage?.ActivateQR}</p>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <h4 style={{ color: '#ec671b' }}>{selectedLanguage?.ScanyourQr}</h4>
                    <QrReader
                        delay={1000}
                        onError={e => errorMessage(selectedLanguage?.WebCamNotFound)}
                        constraints={constraints}
                        onResult={scanQr}
                        style={{ width: '100%' }}
                    />
                </div>
            </Modal>

            <Modal
                // title={<center>
                //     <Title level={4} style={{ color: '#ec671b' }}>{selectedLanguage?.title_GiftCardDetails}</Title>
                // </center>}
                // visible={true}
                // onOk={handleOk}
                className='pop-info-modal'
                style={{ top: '10px' }}
                open={isModalVisible}
                confirmLoading={confirmLoading}
                onCancel={() => setIsModalVisible(false)}
                footer={[
                    <>
                        <Button key='back' onClick={() => setIsModalVisible(false)} style={{ height: '40px', width: '140px', margin: '2px', marginTop: '10px' }}
                            className='addproduct-text'
                            type='primary'>
                            {selectedLanguage?.Cancel}
                        </Button>
                        {giftCardDetail?.userId?._id !== user?._id ?
                            <Button loading={loading} key='backs' onClick={sendAcceptRequest} style={{ height: '40px', width: '180px', margin: '2px', marginTop: '10px' }}
                                className='addproduct-text'
                                type='primary'>
                                {selectedLanguage?.button_ClaimRequestToAdmin}
                            </Button>
                            :
                            <Button loading={loading} key='backs' onClick={acceptCode} style={{ height: '40px', width: '140px', margin: '2px', marginTop: '10px' }}
                                className='addproduct-text'
                                type='primary'>
                                {selectedLanguage?.button_Accept}
                            </Button>
                        }
                    </>
                ]}
            >
                <p className='new-p-question'>{selectedLanguage?.title_GiftCardDetails}</p>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <ul>
                        <li><b>{selectedLanguage?.Amount}: </b>{giftCardDetail?.amount ? giftCardDetail?.amount : '-------'} </li>
                        <li><b>{selectedLanguage?.CreatedAt}: </b>{giftCardDetail?.created ? moment(giftCardDetail?.created)?.format('YYYY-MM-DD') : '-------'} </li>
                        <li><b>{selectedLanguage?.Code}: </b>{giftCardDetail?.giftCardCode ? giftCardDetail?.giftCardCode : '-------'}</li>
                        <li><b>{selectedLanguage?.title_Admin}: </b>{giftCardDetail?.giftCardCode ? `${giftCardDetail?.isAdmin}` : '-------'}</li>
                        <li><b>{selectedLanguage?.title_SeriesName}:</b> {giftCardDetail?.seriesName ? giftCardDetail?.seriesName : '-------'}</li>
                    </ul>
                </div>
            </Modal>
        </div >
    )
}

export default AcceptGiftCards